<script>
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import Navbar from '../navbar/navbar.svelte';
    import Footer from '../landing_page/footer.svelte';
    const {title} = rpcjs.props;
    title.set('Invest');
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<div class="desktop">
    <Navbar />
</div>
<div class="mobile back-img">
    <NavbarMenu backgroundColor="transparent" stroke="black" />
</div>

<div class="desktop">
    <div style="display: flex;margin: 10.868vw;">
        <div class="circle" />
        <div class="circle" />
        <div class="circle" />
    </div>
    <div style="text-align: center;margin-top: -1.78vw;">
        <h1
            style="font-size: 4.037vw;
        text-transform: uppercase;
        color: rgba(0, 32, 75, 1);"
        >
            Invest with Us
        </h1>
        <h1
            style="font-size: 1.984vw;
            padding-right: 6vw;
            width: 57.786vw;
            margin: 2.5vw 23vw auto;
            color: rgb(0, 32, 75);"
        >
            <span
                ><div
                    style="    width: 12.037vw;
                    margin-bottom: 0.5vw;
                    display: inline-block;
                    border-radius: 1.5vw;
                    border-bottom: 0.3vw solid rgb(247, 224, 95);
                    transform: scale(1);
                    margin-right: 2vw;"
                /></span
            >
            We invest in founders building the future. If you want to get involved
            with pre-seed to pre-series A companies, join our investor network!
        </h1>
        <button
            class="btn-css"
            style="position: absolute;right: 44vw;"
            on:click={() => (location.href = '/applyProgram')}>Invest</button
        >
    </div>
    <div style="margin-top: 15.356vw; text-align:center;">
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
        >
            DUV Successful Alumni
        </h1>
    </div>

    <div>
        <img
            alt=""
            src="images/Alumni.png"
            width="100%"
            style="width: 75.716vw;
        margin-left: 12.169vw;
        margin-top: 7.011vw;"
        />
    </div>

    <div style="margin-top:12vw; text-align:center;">
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
        >
            DUV Companies
        </h1>
    </div>

    <div
        style="width: 72.718vw;
margin-top: 4.034vw;
margin-left: 12.963vw;"
    >
        <img alt="" src="images/DUVCompanies.png" width="100%" />
    </div>
</div>
<div class="mobile">
    <div style="display: flex;padding-top:35vw;">
        <div class="circle_mbl" />
        <div class="circle_mbl" />
        <div class="circle_mbl" />
    </div>
    <div style="text-align: center;margin-top: 3.22vw;">
        <h1 style="font-size:9.722vw;text-transform: uppercase;">
            Invest <br /> with Us
        </h1>
        <h1
            style="font-size: 4.444vw; width:78.056vw;margin:auto;margin-top:10vw;text-align: justify;"
        >
            <span
                ><div
                    style="width: 22.196vw;
                    margin-right: 10.5vw;
                    margin-bottom: 0.8vw;
                    display: inline-block;
                    border-radius: 1.5vw;
                    transform: scale(1);
                    border-bottom: 1.389vw solid rgb(247, 224, 95);"
                /></span
            >
            We invest in &ensp; &emsp; &emsp; founders building the future. If you
            want to get involved with pre-seed to pre-series A companies, join our
            investor network!
        </h1>
        <button class="btn-css" on:click={() => (location.href = '/contact_us')}
            >Invest</button
        >
    </div>
    <div style="margin-top:16vw; text-align:center;">
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:5.556vw;text-transform: uppercase;"
        >
            DUV Successful Alumni
        </h1>
    </div>
    <div style="width: 89.778vw;margin: 7vw auto 17vw;">
        <img alt="" src="/images/invest_logos/img2.svg" width="100%" />
    </div>
    <div style="margin-top:12vw; text-align:center;">
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:5.556vw;text-transform: uppercase;"
        >
            DUV Companies
        </h1>
    </div>
    <div style="width: 89.778vw;margin: 7vw auto 13vw;">
        <img alt="" src="/images/invest_logos/img1.svg" width="100%" />
    </div>
</div>
<div style="margin-top: 7vw;">
    <Footer />
</div>

<style>
    /* .nav-main {
        display: flex;
        position: absolute;
        z-index: 1;
        top: 2.2vw;
        left: 0.8vw;
    }
    .logo-wrraper {
        width: 10vw;
        margin-left: 5.82vw;
        display: flex;
    } */
    .circle {
        height: 35.251vw;
        width: 35.251vw;
        border-radius: 50%;
        opacity: 0.2;
        position: absolute;
        margin-top: 1vw;
        left: -23vw;
        background-color: rgba(60, 136, 195, 0.33);
    }
    .circle:nth-child(2) {
        left: 3.63vw;
    }
    .circle:nth-child(3) {
        left: 30vw;
    }
    .circle_mbl {
        height: 51.389vw;
        width: 51.389vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        opacity: 0.2;
        left: -25vw;
        background-color: rgba(60, 136, 195, 0.33);
    }
    .circle_mbl:nth-child(2) {
        left: 10vw;
    }
    .circle_mbl:nth-child(3) {
        left: 45vw;
    }
    .btn-css {
        background-color: #3c74c0;
        border-radius: 1.984vw;
        color: white;
        font-weight: 500;
        border: none;
        font-size: 1.058vw;
        margin-top: 3vw;
        z-index: 50;
        width: 13.228vw;
        height: 3.638vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .btn-css {
            width: 45.556vw;
            height: 11.112vw;
            font-size: 3.333vw !important;
            margin-top: 13vw !important;
            border-radius: 8.333vw !important;
        }
    }
    /* .corner-left {
        width: 8.611vw;
        height: 8.611vw;
        position: absolute;
        border: 1.389vw solid #7cc1ff;
        border-bottom: none;
        border-right: none;
        left: 4.278vw;
        top: -3vw;
    }
    .corner-right {
        width: 8.611vw;
        height: 8.611vw;
        position: absolute;
        border: 1.389vw solid #7cc1ff;
        border-top: none;
        border-left: none;
        right: 8.278vw;
        bottom: 1.5vw;
    }
    .social-icon {
        display: flex;
        width: 72.751vw;
        height: 10vw;
        justify-content: space-between;
        margin-left: 13.624vw;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 8vw;
    } */
</style>
